<template>
  <BaseTemplate >
    <div class="bg_white pt16 pb16 boxs1">
        <GeneralTitle :title="'セミナールーム利用申請(予約)'" />
        <dl class="data mt20 pl16 pr16">
          <div class="data_list">
            <dt class="data_title ab">利用するサロン</dt>
            <dd class="data_text ab">{{ getSalonContents().salonName }}</dd>
          </div>
          <div class="data_list">
            <dt class="data_title ab">利用する部屋</dt>
            <dd class="data_text ab">{{ getRoomContents().roomName }}</dd>
          </div>
          <div class="data_list">
            <dt class="data_title ab">開催日</dt>
            <dd class="data_text rb">{{ formatDate(getBussinesDayContents().businessDay) }}</dd>
          </div>
          <div class="data_list">
            <dt class="data_title ab">利用開始時間</dt>
            <dd class="data_text rb">{{ getStartTImeContents().hhMM }}</dd>
          </div>
          <div class="data_list">
            <dt class="data_title ab">利用終了時間</dt>
            <dd class="data_text rb">{{ getEndTImeContents().hhMM }}</dd>
          </div>
        </dl>

        <div v-if="getSelectedRoom().inputSeminarInfo" class="seminar pb24">
          <GeneralTitle :title="'主催者(代表者)情報'" class="mt40" />
          <dl class="data mt20 pl16 pr16">
            <div class="data_title rb">主催者</div>
            <div class="data_list">
              <dt class="data_title ab">主催者会員番号</dt>
              <dd class="data_text ab">{{ SEMINAR_INFO.organizerMemberId1 }}</dd>
            </div>
            <div class="data_list">
              <dt class="data_title ab">主催者氏名</dt>
              <dd class="data_text ab">{{ SEMINAR_INFO.organizerMemberName1 }}</dd>
            </div>
            <div class="data_list">
              <dt class="data_title ab">主催者電話番号</dt>
              <dd class="data_text rb">{{ SEMINAR_INFO.organizerMemberTel1 }}</dd>
            </div>
          </dl>
          <dl v-if="SEMINAR_INFO.organizerMemberId2 != '' && SEMINAR_INFO.organizerMemberName2 != '' && SEMINAR_INFO.organizerMemberTel2 != ''" class="data mt20 pl16 pr16">
            <div class="data_title rb">主催者②</div>
            <div v-if="SEMINAR_INFO.organizerMemberId2 != ''" class="data_list">
              <dt class="data_title ab">主催者会員番号②</dt>
              <dd class="data_text ab">{{ SEMINAR_INFO.organizerMemberId2 }}</dd>
            </div>
            <div v-if="SEMINAR_INFO.organizerMemberName2 != ''" class="data_list">
              <dt class="data_title ab">主催者氏名②</dt>
              <dd class="data_text ab">{{ SEMINAR_INFO.organizerMemberName2 }}</dd>
            </div>
            <div v-if="SEMINAR_INFO.organizerMemberTel2 != ''" class="data_list">
              <dt class="data_title ab">主催者電話番号②</dt>
              <dd class="data_text rb">{{ SEMINAR_INFO.organizerMemberTel2 }}</dd>
            </div>
          </dl>
            <dl v-if="SEMINAR_INFO.organizerMemberId3 != '' && SEMINAR_INFO.organizerMemberName3 != '' && SEMINAR_INFO.organizerMemberTel3 != ''" class="data mt20 pl16 pr16">
            <div class="data_title rb">主催者③</div>
            <div v-if="SEMINAR_INFO.organizerMemberId3 != ''" class="data_list">
              <dt class="data_title ab">主催者会員番号③</dt>
              <dd class="data_text ab">{{ SEMINAR_INFO.organizerMemberId3 }}</dd>
            </div>
            <div v-if="SEMINAR_INFO.organizerMemberName3 != ''" class="data_list">
              <dt class="data_title ab">主催者氏名③</dt>
              <dd class="data_text ab">{{ SEMINAR_INFO.organizerMemberName3 }}</dd>
            </div>
            <div v-if="SEMINAR_INFO.organizerMemberTel3 != ''" class="data_list">
              <dt class="data_title ab">主催者電話番号③</dt>
              <dd class="data_text rb">{{ SEMINAR_INFO.organizerMemberTel3 }}</dd>
            </div>
          </dl>

          <GeneralTitle :title="'講師情報'" class="mt40" />
          <dl class="data mt20 pl16 pr16">
            <div class="data_title rb">講師</div>
            <div class="data_list">
              <dt class="data_title ab">講師会員番号</dt>
              <dd class="data_text ab">{{ SEMINAR_INFO.instructorMemberId1 }}</dd>
            </div>
            <div class="data_list">
              <dt class="data_title ab">講師氏名</dt>
              <dd class="data_text ab">{{ SEMINAR_INFO.instructorMemberName1 }}</dd>
            </div>
          </dl>
          <dl v-if="SEMINAR_INFO.instructorMemberId2 != '' && SEMINAR_INFO.instructorMemberName2 != ''" class="data mt20 pl16 pr16">
            <div class="data_title rb">講師②</div>
            <div v-if="SEMINAR_INFO.instructorMemberId2 != ''" class="data_list">
              <dt class="data_title ab">講師会員番号②</dt>
              <dd class="data_text ab">{{ SEMINAR_INFO.instructorMemberId2 }}</dd>
            </div>
            <div v-if="SEMINAR_INFO.instructorMemberName2 != ''" class="data_list">
              <dt class="data_title ab">講師氏名②</dt>
              <dd class="data_text ab">{{ SEMINAR_INFO.instructorMemberName2 }}</dd>
            </div>
          </dl>
          <dl v-if="SEMINAR_INFO.instructorMemberId3 != '' && SEMINAR_INFO.instructorMemberName3 != ''" class="data mt20 pl16 pr16">
            <div class="data_title rb">講師③</div>
            <div v-if="SEMINAR_INFO.instructorMemberId3 != ''" class="data_list">
              <dt class="data_title ab">講師会員番号③</dt>
              <dd class="data_text ab">{{ SEMINAR_INFO.instructorMemberId3 }}</dd>
            </div>
            <div v-if="SEMINAR_INFO.instructorMemberName3 != ''" class="data_list">
              <dt class="data_title ab">講師氏名③</dt>
              <dd class="data_text ab">{{ SEMINAR_INFO.instructorMemberName3 }}</dd>
            </div>
          </dl>

          <GeneralTitle :title="'セミナー情報'" class="mt40" />
          <dl class="data mt20 pl16 pr16">
            <div :style="{ marginLeft: 0 }" class="data_list">
              <dt class="data_title ab">セミナー名称(タイトル)</dt>
              <dd class="data_text ab">{{ SEMINAR_INFO.title }}</dd>
            </div>
            <div :style="{ marginLeft: 0 }" class="data_list">
              <dt class="data_title ab">セミナー種別</dt>
              <dd class="data_text ab">{{ findSeminarTyoeText().seminarTypeText }}</dd>
            </div>
            <div :style="{ marginLeft: 0 }" class="data_list">
              <dt class="data_title ab">セミナー開催時間</dt>
              <dd class="data_text rb">{{ zeroPad(SEMINAR_INFO.hourFrom, 2) }}:{{ zeroPad(SEMINAR_INFO.minuteFrom, 2) }}</dd>
            </div>
            <div :style="{ marginLeft: 0 }" class="data_list">
              <dt class="data_title ab">セミナー終了時間</dt>
              <dd class="data_text rb">{{ zeroPad(SEMINAR_INFO.hourTo, 2) }}:{{ zeroPad(SEMINAR_INFO.minuteTo, 2) }}</dd>
            </div>
            <div :style="{ marginLeft: 0, marginTop: '28px' }" class="data_list">
              <dt class="data_title ab">受講料有無</dt>
              <dd class="data_text rb">{{ SEMINAR_INFO.paid ? '有料' : '無料' }}</dd>
            </div>
            <div :style="{ marginLeft: 0 }" v-if="SEMINAR_INFO.paid" class="data_list">
              <dt class="data_title ab">受講料</dt>
              <dd class="data_text rb">{{ SEMINAR_INFO.courseFee }}</dd>
            </div>
            <div  :style="{ marginLeft: 0, marginTop: '28px' }" class="data_list remark">
              <dt class="data_title ab">備考</dt>
              <dd class="data_text rb">{{ SEMINAR_INFO.remark }}</dd>
            </div>
          </dl>

        </div>
    </div>
    <div v-if="!isReserveSuccess" class="bg_white mt16 pt16 pb48 boxs1">
      <div v-if="getSelectedRoom().inputSeminarInfo" class="seminar_caution">
        <GeneralTitle :title="'セミナー申し込み確認事項'" class="" />
        <h2 class="confirm_title ab pl16 pr16">【申請にあたってのご注意】</h2>
        <div class="seminar_caution_wrap pl16 pr16">
          <p class="seminar_cautio_text ar">①当フォームにセミナー情報、主催者情報を入力し送信すると、セミナールーム利用申請の受付、および弊社公式ホームページ内「セミナー情報」に掲載いたします</p>
          <p class="seminar_cautio_text ar">②ご入力の内容に関して、確認事項が発生した場合は主催（代表）の方にご連絡を差し上げる場合があります。</p>
          <p class="seminar_cautio_text ar">③セミナーの変更・キャンセルはこのフォームで受付できませんのであらかじめご了承ください。</p>
        </div>
      </div>
      <div class="confirm mt16 pl16 pr16" :class="{ mt16: !getSelectedRoom().inputSeminarInfo, mt48: getSelectedRoom().inputSeminarInfo }">
        <p class="confirm_text ab">本規約をご確認の上「同意して利用する」<br>ボタンをタップしてお進みください</p>
        <div class="btn_wrap">
          <a :href="showTermsOfService()" class="btn btn_yellow" target="_blank" rel="noopener noreferrer">規約を表示</a>
        </div>

        <div class="terms_check">
          <input v-model="termCheck" type="checkbox" id="terms" class="hidden-checkbox"/>
          <label for="terms" class="styled-checkbox"></label>
          <label for="terms" class="terms_label ab">利用規約に同意する</label>
        </div>
      </div>

      <div class="submit_wrap  pl16 pr16">
        <div v-if="!termCheck" class="disable_btn ab">上記の内容で予約送信</div>
        <BaseBtn v-else="termCheck" :btnText="'上記の内容で予約送信'" :type="'blue'" @onClick="onClickSubmit" :disabled="submit_disabled" />
        <div class="delete_wrap">
          <BaseBtn :btnText="'戻る'" :type="'delete'" @onClick="onClickPageBack" />
        </div>
      </div>
    </div>

    <BaseModal v-if="isModarOpen">
        <div v-for="(value, index) in messageList" class="ab error_text" :key="index">{{ value }}</div>
        <div class="mt16">
          <BaseBtn :btnText="'閉じる'" :type="'delete'" @onClick="onClickCloseModal" />
        </div>
      </BaseModal>

      <Loading v-show="loading" />
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import Config from '@/config/config';
import SalonApi from '@/components/api/salon/reservation';
import BaseTemplate from '@/views/common/BaseTemplate.vue';
import GeneralTitle from '@/components/common/GeneralTitle.vue';
import BaseBtn from '@/components/common/BaseBtn.vue';
import BaseModal from '@/components/common/BaseModal.vue';
import Loading from '@/components/common/Loading';

export default {
  components: {
      GeneralTitle,
      BaseTemplate,
      BaseBtn,
      BaseModal,
      Loading
  },
  data() {
      return {
          Config: Config,
          messageList: [],
          termCheck: false,
          isModarOpen: false,
          isReserveSuccess: false,
          loading: false, // ローディング用
          submit_disabled: false, // 送信ボタンの無効化
      }
  },
  methods: {
    findSeminarTyoeText() {
      return this.SEMINAR_TYPE_LIST.find((val) => {
        return val.seminarType === this.SEMINAR_INFO.seminarType;
      });
    },
    zeroPad(number, length) {
      return number.toString().padStart(length, '0');
    },
    formatDate(dateStr) {
      let date = new Date(dateStr);
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();

      let weekdayNumber = date.getDay();
      let weekday = ["日曜日", "月曜日", "火曜日", "水曜日", "木曜日", "金曜日", "土曜日"][weekdayNumber];

      let formattedDate = `${year}年${month}月${day}日 ${weekday}`;

      console.log(formattedDate);
      return formattedDate;
    },
    showTermsOfService() {
      return `${Config.APIURL}/api/salon/reservation/showTermsOfService?salonId=${this.RESERVATION_SELECTED_SALON_ID}&openExternalBrowser=1`;
    },
    getSalonContents() {
      const salonData = this.RESERVATION_SALON_LIST.find((val) => {
        return val.salonId == this.RESERVATION_SELECTED_SALON_ID;
      });

      if(!salonData) return '';
      return salonData;
    },
    getRoomContents() {
      const roomData = this.RESERVATION_ROOM_LIST.find((val) => {
        return val.roomId == this.RESERVATION_SELECTED_ROOM_ID;
      });

      if(!roomData) return '';
      return roomData;
    },
    getBussinesDayContents() {
      const bussinesDayData = this.RESERVATION_BUSINESS_DAY_LIST.find((val) => {
        return val.businessDay == this.RESERVATION_SELECTED_BUSINESS_DAY;
      });

      if(!bussinesDayData) return '';
      return bussinesDayData;
    },
    getStartTImeContents() {
      const hourData = this.RESERVATION_START_LIST.find((val) => {
        return val.hour == this.RESERVATION_SELECTED_START_LIST_HOUR;
      });

      if(!hourData) return '';
      const minuteData = hourData.minuteList.find((value) => {
        return value.minute == this.RESERVATION_SELECTED_START_LIST_MINUTE;
      });

      if(!minuteData) return '';
      return minuteData;
    },
    getEndTImeContents() {
      const hourData = this.RESERVATION_END_LIST.find((val) => {
        return val.hour == this.RESERVATION_SELECTED_END_LIST_HOUR;
      });

      if(!hourData) return '';
      const minuteData = hourData.minuteList.find((value) => {
        return value.minute == this.RESERVATION_SELECTED_END_LIST_MINUTE;
      });

      if(!minuteData) return '';
      return minuteData;
    },
    getSelectedRoom() {
      return this.RESERVATION_ROOM_LIST.find((val) => {
        return val.roomId == this.RESERVATION_SELECTED_ROOM_ID;
      });
    },
    async onClickSubmit() {
      this.loading = true;
      this.submit_disabled = true;
      let requestData = this.API_RESERVATION_SALON_REQUEST_DATA;

      const selecedRoom = this.getSelectedRoom();
        if(selecedRoom.inputSeminarInfo) {
          requestData.seminarInfo = this.SEMINAR_INFO;
        }
        console.log('リクエスト');
        console.log(requestData);
        await this.apiReserve(requestData).then((val) => {
          this.loading = false;
          if(val.status == 'OK') {
            this.messageList.push('予約が完了しました。');
            this.isModarOpen = true;
            this.isReserveSuccess = true;
          }

          if(val.status == 400) {
            this.submit_disabled = false;
            console.log(val['message']);
            this.messageList.push(val['message']);
            this.isModarOpen = true;
          }
        });
    },
    onClickCloseModal() {
      this.isModarOpen = false;
      this.errorList = [];
    },
    onClickPageBack() {
      console.log('pageback');
      this.$router.push({name: this.$route.query.backUrl});
    },
    async apiReserve(payload) {
      return await SalonApi.reserve(payload).then((val) => {
        console.log(val);
        return val;
      });
    }
  },
  async created() {
      // await this.apiGetSalonList();
      // await this.apiGetAvailabilityStatusTable();
  },
  computed: mapGetters(
    'salon', [
      'RESERVATION_SALON_LIST',
      'RESERVATION_SELECTED_SALON_ID',
      'RESERVATION_BUSINESS_DAY_LIST',
      'RESERVATION_SELECTED_BUSINESS_DAY',
      'RESERVATION_ROOM_LIST',
      'RESERVATION_SELECTED_ROOM_ID',
      'RESERVATION_START_LIST',
      'RESERVATION_SELECTED_START_LIST_HOUR',
      'RESERVATION_SELECTED_START_LIST_MINUTE',
      'RESERVATION_END_LIST',
      'RESERVATION_SELECTED_END_LIST_HOUR',
      'RESERVATION_SELECTED_END_LIST_MINUTE',
      'SEMINAR_INFO',
      'SEMINAR_TYPE_LIST',
      'API_RESERVATION_SALON_REQUEST_DATA',
    ],
  ),
}
</script>

<style lang="css" scoped>
.data {
  margin-top: 20px;
}

.data_list {
  align-items: flex-start;
  display: flex;
  font-size: 14px;
  justify-content: space-between;
  line-height: 1;
}
.data_list.remark {
  flex-direction: column;
}
.data_list.remark .data_title,
.data_list.remark .data_text {
  justify-content: flex-start;
  text-align: left;
  width: 100%;
}
.data_list.remark .data_text {
  margin-top: 8px;
}
.data_list:not(:first-child) {
  margin-top: 14px;
}
.seminar .data_list {
  margin-left: 24px;
}
.data_title,
.data_text {
  width: 45%;
}
.data_text {
  display: flex;
  justify-content: flex-end;
  text-align: right;
}

.confirm_text {
  font-size: 16px;
  line-height: 1.5;
  text-align: center;
}
.confirm .btn_wrap {
  margin-top: 32px;
}

.hidden-checkbox {
    display: none;
}

.styled-checkbox {
    width: 22px;
    height: 22px;
    background: #fff;
    display: inline-block;
    position: relative;
    border: 1px solid #5A5A5A;
}

.styled-checkbox:after {
    content: "";
    display: none;
    position: absolute;
    width: 6px;
    height: 12px;
    border: solid #4FCCD4;
    border-width: 0 3px 3px 0;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(45deg);
}

.hidden-checkbox:checked + .styled-checkbox:after {
    display: block;
}

.terms_check {
  align-items: center;
  display: flex;
  justify-content: center;
  margin-top: 48px;
}
.terms_label {
  font-size: 18px;
  margin-left: 8px;
}

.submit_wrap {
  margin-top: 98px;
}

.disable_btn {
  border: 1px solid #C5C5C7;
  border-radius: 20px;
  background-color: #F4F4F4;
  color: #C5C5C7;
  font-size: 14px;
  padding: 8px;
  text-align: center;
  width: 100%;
}

.delete_wrap {
  margin-top: 23px;
}

.seminar_caution .confirm_title {
  font-size: 16px;
  margin-top: 24px;
}
.seminar_caution_wrap {
  margin-top: 12px;
}
.seminar_caution .seminar_cautio_text {
  font-size: 12px;
}
.seminar_caution .seminar_cautio_text:not(:first-child) {
  margin-top: 16px;
}
</style>



// WEBPACK FOOTER //
// src/views/salon/ReservationConfirm.vue